import React, { memo } from 'react';
import { Pagina } from '../../componentes/pagina';
export default memo(function BlogPagina() {
  return  <Pagina titulo={"Blog"}> unidades</Pagina>;
});
  